/**
 * Returns true if val is a non-empty array of document-like objects (each has link or title).
 * Uses strict equality for null/undefined checks.
 */
export function isDocumentFieldValue(val) {
  if (!Array.isArray(val) || val.length === 0) return false;
  const first = val[0];
  if (typeof first !== 'object' || first === null) return false;
  const hasLink = first.link !== undefined && first.link !== null;
  const hasTitle = first.title !== undefined && first.title !== null;
  return hasLink || hasTitle;
}
